import React from "react";
import {farpittjonline} from "./Images/ProjectImages/ttjonline.png"


const ProjectCards = (props) => {
  return (
    <div className="p-item">
      <img src={props.image} />
      <div className="item-info">
        <caption>{props.title}</caption>
        <p>
          {props.description}
        </p>
        <div className="item-used">
          <ul>
            <li>
              <span>{props.item1}</span>
            </li>
            <li>
              <span>{props.item2}</span>
            </li>
            <li>
              <span>{props.item3}</span>
            </li>
          </ul>
        </div>
        <div className="item-status">
            <span>
                <i class="fa-solid fa-heart"></i>

            </span>
            <a target="_blank" href={props.link}>
                <i class="fa-solid fa-link"></i>
            </a>
          <span className="item-status-date">{props.date}</span>
        </div>
      </div>
    </div>
  );
};

export default ProjectCards;